<template>
  <nav aria-label="Page navigation" v-if="total > 0">
    <ul class="pagination justify-content-center">
      <li class="page-item" v-bind:class="{ disabled: current <= 1 }" v-show="!(current <= 1)">
        <a class="page-link border-primary text-primary" @click="go(current - 1)">&lt;</a>
      </li>
      <li class="page-item" v-for="page in range" v-bind:class="{ active: page === current }" :key="page">
        <a class="page-link border-primary text-primary" @click="go(page)">{{ (page >= 10) ? page : '0' + page }}</a>
      </li>
      <li class="page-item" v-bind:class="{ disabled: current >= total }" v-show="!(current >= total)">
        <a class="page-link border-primary text-primary" @click="go(current + 1)">&gt;</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Pagination',

  props: {
    current: {
      type: Number,
      required: true,
      default: 1
    },

    total: {
      type: Number,
      required: true,
      default: 5
    }
  },

  computed: {
    range () {
      const start = this.current - 5 > 0 ? this.current - 5 : 1
      const end = this.current + 5 < this.total ? this.current + 5 : this.total
      return Array.from({ length: end - start + 1 }, (_, index) => start + index)
    }
  },

  methods: {
    go (page) {
      const toPage = page >= 1 && page <= this.total ? page : this.current
      this.$emit('page', toPage)
      this.scrollTop()
    },

    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop

      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  // @import "../assets/all.scss";
  .page-item {
    margin-right: 1em;
    box-shadow: none !important;
    cursor: pointer;
    &.active {
      .page-link {
        background-color: blue !important;
        color: white !important;
        border: 1px solid  blue !important;
      }
    }

    .page-link {
      background-color: transparent !important;
      color: blue !important;
      font-weight: 800;
      border: 1px solid blue !important;
    }
  }
</style>
